import { render, staticRenderFns } from "./otherConfirmPay.vue?vue&type=template&id=2a27a895&scoped=true&"
import script from "./otherConfirmPay.vue?vue&type=script&lang=js&"
export * from "./otherConfirmPay.vue?vue&type=script&lang=js&"
import style0 from "./otherConfirmPay.vue?vue&type=style&index=0&id=2a27a895&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a27a895",
  null
  
)

export default component.exports